// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__1xjzz","active":"Tag_active__38EaV"};